<template>
  <div v-if="visible" class="bc-offpay-mask" @click.self="onClose">
    <div class="bc-offpay">
      <button type="button" class="bc-offpay__close" @click="onClose">×</button>
      <h2 class="bc-offpay__title">{{ $T('观众中心线下收款') }}</h2>
      <p v-if="payPrice" class="bc-offpay__amount">
        {{ $T('观众中心应付') }}：<strong>{{ money(payPrice) }}</strong>
      </p>
      <p class="bc-offpay__hint">{{ $T('观众中心线下收款说明') }}</p>

      <div v-if="loading" class="bc-offpay__loading">{{ $T('观众中心加载中') }}</div>
      <template v-else>
        <div class="bc-offpay__qr-wrap" v-if="account.qrcode_url">
          <img class="bc-offpay__qr" :src="account.qrcode_url" :alt="$T('观众中心收款二维码')" />
          <p class="bc-offpay__qr-tip">{{ $T('观众中心扫码付款') }}</p>
        </div>

        <div class="bc-offpay__account">
          <h3>{{ account.title || 'Company Account' }}</h3>
          <dl>
            <div>
              <dt>Beneficiary Name</dt>
              <dd>{{ account.beneficiary_name }}</dd>
            </div>
            <div>
              <dt>Beneficiary Account No.</dt>
              <dd>{{ account.beneficiary_account }}</dd>
            </div>
            <div>
              <dt>Bank Name</dt>
              <dd>{{ account.bank_name }}</dd>
            </div>
            <div>
              <dt>SWIFT Code</dt>
              <dd>{{ account.swift_code }}</dd>
            </div>
            <div>
              <dt>Bank Address</dt>
              <dd>{{ account.bank_address }}</dd>
            </div>
          </dl>
        </div>

        <button type="button" class="bc-offpay__btn" @click="onPaid">
          {{ $T('观众中心我已支付') }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { spectatorMoney } from '@/utils/spectatorMoney';

export default {
  name: 'SpectatorOfflinePayDialog',
  props: {
    show: { type: Boolean, default: false },
    ids: {
      type: Array,
      default() {
        return [];
      },
    },
    payPrice: { type: [Number, String], default: '' },
  },
  data() {
    return {
      visible: false,
      loading: false,
      account: {},
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val;
        if (val) {
          this.fetchAccount();
        }
      },
    },
  },
  methods: {
    money: spectatorMoney,
    fetchAccount() {
      const that = this;
      that.loading = true;
      that.$api.get(
        '/api/order/offlinePayInfo',
        {},
        (res) => {
          that.account = res.data || {};
          that.loading = false;
        },
        () => {
          that.account = {};
          that.loading = false;
        }
      );
    },
    onClose() {
      this.$emit('onClose');
    },
    onPaid() {
      const that = this;
      const ids = that.ids || [];
      if (!ids.length) {
        that.$emit('onPaid', ids);
        return;
      }
      that.$api.post(
        '/api/order/markOfflinePay',
        { ids },
        () => {
          that.$emit('onPaid', ids);
        },
        () => {
          // 标记失败仍允许去上传凭证
          that.$emit('onPaid', ids);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-offpay-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.bc-offpay {
  position: relative;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 14px;
  padding: 28px 24px 24px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.2);
}
.bc-offpay__close {
  position: absolute;
  top: 10px;
  right: 14px;
  border: 0;
  background: none;
  font-size: 28px;
  line-height: 1;
  color: #9ca3af;
  cursor: pointer;
}
.bc-offpay__title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #1e2842;
  text-align: center;
}
.bc-offpay__amount {
  margin: 0 0 8px;
  text-align: center;
  font-size: 15px;
  color: #374151;
}
.bc-offpay__amount strong {
  color: #c2410c;
  font-size: 22px;
}
.bc-offpay__hint {
  margin: 0 0 20px;
  text-align: center;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}
.bc-offpay__loading {
  text-align: center;
  color: #6b7280;
  padding: 24px 0;
}
.bc-offpay__qr-wrap {
  text-align: center;
  margin-bottom: 20px;
}
.bc-offpay__qr {
  width: 200px;
  height: 200px;
  object-fit: contain;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.bc-offpay__qr-tip {
  margin: 8px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.bc-offpay__account {
  background: #f8fafc;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
}
.bc-offpay__account h3 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: #1e2842;
}
.bc-offpay__account dl {
  margin: 0;
}
.bc-offpay__account dl > div {
  margin-bottom: 10px;
}
.bc-offpay__account dl > div:last-child {
  margin-bottom: 0;
}
.bc-offpay__account dt {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 2px;
}
.bc-offpay__account dd {
  margin: 0;
  font-size: 13px;
  color: #1e2842;
  line-height: 1.4;
  word-break: break-word;
}
.bc-offpay__btn {
  display: block;
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 8px;
  background: #c2410c;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.bc-offpay__btn:hover {
  background: #9a3412;
}
</style>



// WEBPACK FOOTER //
// SpectatorOfflinePayDialog.vue?6199dc9a